import type { IconName } from "@/components/ui/Icon";

/** Maps an amenity label to the glyph used on property cards and detail pages. */
const AMENITY_ICONS: Record<string, IconName> = {
  Clubhouse: "clubhouse",
  "Swimming Pool": "pool",
  Gymnasium: "gym",
  "Landscaped Park": "park",
  "24×7 Security": "security",
  "Solar Power": "solar",
  "EV Charging": "parking",
  "Rainwater Harvesting": "water",
  "Covered Parking": "parking",
  "High-Speed Lifts": "elevator",
  Cafeteria: "clubhouse",
};

export function amenityIcon(name: string): IconName {
  return AMENITY_ICONS[name] ?? "check";
}
